<template>
  <div>
    <mm-form
      layout="vertical"
      class="auth-form"
      ref="validForm"
      :rules="rules"
      :data="model"
    >
      <mm-form-field
        :label="$t('auth.companyName')"
        field="companyName"
        name="companyName"
      >
        <mm-input
          :disabled="isVerified"
          v-model="model.companyName"
        />
      </mm-form-field>
      <mm-form-field
        v-if="isForeignCurrency"
        class="form-item"
        :label="$t('auth.translatedName')"
        field="translatedName"
        :disabled="isVerified"
      >
        <mm-input v-model="model.translatedName" />
      </mm-form-field>
      <mm-form-field
        :label="$t('auth.creditCode')"
        field="creditCode"
        name="creditCode"
        class="form-credit-code"
      >
        <mm-input
          v-model="model.creditCode"
          :disabled="isVerified"
        />
        <mm-button
          v-if="!isOversea"
          :disabled="isVerified"
          type="primary"
          class="verify-btn"
          style="margin-left: 16px;"
          @click="verifyCreditCode"
        >
          {{ $t('auth.verify') }}
        </mm-button>
      </mm-form-field>
      <mm-form-field
        :label="$t('auth.license')"
        field="license"
      >
        <upload-file
          v-model="model.license"
          accept="image/*, .pdf"
        />
        <p
          class="license-tips"
          v-t="'auth.licenseTips'"
        />
      </mm-form-field>
      
      <mm-form-field
        :label="$t('auth.mobile')"
        field="mobile"
        name="mobile"
      >
        <!-- 已有手机号则不能不能编辑 -->
        <div class="form-input-box form-mobile">
          <mm-select
            v-model="model.countryCode"
            :options="countryCodeOption"
            :disabled="isDisabledMobile"
            :keymap="{
              value: 'code'
            }"
            show-arrow
            filterable
          >
            <span
              slot="option"
              slot-scope="{ code, name, eng_name }"
              :title="`+${code} (${eng_name}/${name})`"
            >
              {{ `+${code}` }}
            </span>
          </mm-select>
          <mm-input
            v-model="model.mobile"
            :disabled="isDisabledMobile"
          />
        </div>
      </mm-form-field>
      <mm-form-field
        :label="$t('auth.code')"
        field="imgCode"
        name="imgCode"
      >
        <div class="form-input-box">
          <div id="slide-vertify-code" />
        </div>
      </mm-form-field>
      <mm-form-field
        :label="$t('auth.sms')"
        field="mobileCode"
      >
        <div class="form-input-box">
          <mm-input v-model="model.mobileCode" />
          <mm-button
            v-if="!showSmsCountDown"
            class="sms-button"
            :disabled="smsDisabled"
            @click="handleFetchSmsCode"
          >
            {{ $t('auth.getSms') }}
          </mm-button>
          <mm-button
            v-else
            class="sms-button"
            disabled
          >
            ({{ smsCountDown }})s
          </mm-button>
        </div>
      </mm-form-field>
    </mm-form>
    <div class="footer">
      <mm-button @click="handleCancle">
        {{ $t('auth.close') }}
      </mm-button>
      <mm-button
        @click="handleSubmit"
        type="primary"
        :disabled="isSubmitable"
      >
        {{ $t('auth.submit') }}
      </mm-button>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import MainApi from '@api/main'
  import UploadFile from '@components/UploadFile'
  import COUNTRY_CODE from '@utils/countryCode'
  import I18n from "@i18n";
  

  export default {
    name: 'CompanyVerifyForm',
    data () {
      return {
        model: {
          companyName: '',
          translatedName: '',
          creditCode: '',
          license: '',
          countryCode: '86',
          mobile: '',
          mobileCode: '',
        },
        isVerified: false, // 是否通过 统一社会信用代码 验证
        verifing: false, // 请求验证中
        isDisabledMobile: true,
        imageCodeUrl: '',
        showSmsCountDown: false,
        smsCountDown: 0,
        countryCodeOption: COUNTRY_CODE.map(item => {
          const { code, name, eng_name } = item
          return {
            label: '+' + code,
            code,
            name,
            eng_name
          }
        }),
        ncParams: {
          csessionid: "",
          nc_token: "",
          sig: "",
          scene: ""
        },
        smsDisabled: true,
        rules: Object.freeze({
          companyName: [
            { required: true, message: this.$t('auth.message.companyName') }
          ],
          translatedName: [
            { required: true, message: this.$t('auth.message.translatedName') },
            { 
              validator: (rule, value, callback) => {
                const isAllZh = /^[\u4e00-\u9fa5()（）]+$/ // 纯中文
                const cName = this.model.companyName
                if (isAllZh.test(value) || isAllZh.test(cName)) {
                  callback()
                } else {
                  callback(this.$t('auth.message.transNameError'))
                }
              }
            }
          ],
          creditCode: [
            { required: true, message: this.$t('auth.message.creditCode') },
            { 
              validator: (rule, value, callback) => {
                let patrn = /^[0-9A-Z]+$/i
                if (!patrn.test(value)) {
                  callback(this.$t('auth.message.errCreditCode'))
                } else {
                  callback()
                }
              },
              triggers: ["input"]
            }
          ],
          license: [
            { type: "array", required: true, message: this.$t('auth.message.license') }
          ],
          mobile: [
            { validator: (rule, value, callback) => {
                if (!/^\d{3,20}$/.test(value.trim())) {
                  callback(this.$t('auth.message.mobile'))
                } else {
                  callback()
                }
              } 
            }
          ],
          mobileCode: [
            { required: true, message: this.$t('auth.message.mobileCode') }
          ]
        })
      }
    },
    computed: {
      isSubmitable() {
        if (this.isOversea || this.verifing) {
          // 海外用户不需要验证 企业统一信用码
          return false
        }
        return !this.isVerified
      },
      ...mapState('main', {
        verification: state => state.userInfo.verification,
        userInfo: state => state.userInfo.user
      }),
      ...mapGetters('main', ['isForeignCurrency', 'isOversea'])
    },
    watch: {
      verification: {
        handler(val) {
          const { company_name, credit_code, license } = val
          this.model.companyName = company_name
          this.model.creditCode = credit_code
          this.model.license = license !== '' ? [{
            uid: Math.random() * 10000,
            name: 'license',
            thumbUrl: license,
            url: license
          }] : []
        },
        immediate: true
      },
      userInfo: {
        handler(val) {
          const { country_code, user_mobile } = val
          this.model.countryCode = country_code || '86'
          this.model.mobile = user_mobile
          // 已有手机号则禁止编辑
          this.isDisabledMobile = this.model.mobile > 0
        },
        immediate: true
      }
    },
    created () {
      this.$nextTick(() => {
        this.ncHandle();
      });
    },
    methods: {
      ...mapActions('main', ['fetchUserInfo']),
      ncHandle() {
        const { noCaptcha: NoCaptcha } = window;
        const that = this;
        const nc_token = [
          "FFFF0N00000000008958",
          new Date().getTime(),
          Math.random()
        ].join(":");
        const NC_Opt = {
          renderTo: "#slide-vertify-code",
          appkey: "FFFF0N00000000008958",
          scene: "nc_register",
          token: nc_token,
          customWidth: 420,
          language: "cn",
          isEnabled: true,
          timeout: 3000,
          times: 5,
          callback(data) {
            that.ncParams = {
              nc_token,
              csessionid: data.csessionid,
              sig: data.sig,
              scene: "nc_register"
            };
            that.smsDisabled = false;
          }
        };
        const nc = new NoCaptcha(NC_Opt);
        this.noCaptcha = nc;
        nc.upLang("cn", {
          _startTEXT: I18n.t("auth.ci63ee"),
          _yesTEXT: I18n.t("auth.caf5sf"),
          _error300: `${I18n.t(
            "auth.cybpop"
          )}<a href="javascript:__nc.reset()">${I18n.t(
            "auth.wgmi3n"
          )}</a>${I18n.t("auth.f1v4y4")}`,
          _errorNetwork: `${I18n.t(
            "auth.8hok49"
          )}<a href="javascript:__nc.reset()">${I18n.t("auth.wgmi3n")}</a>`
        });
      },
      handleFetchSmsCode () {
        // 发送验证码倒计时
        const runSmsCountDown = () => {
          this.showSmsCountDown = true
          let defaultTime = 60
          let timer = ''
          const timeOut = () => {
            this.smsCountDown = defaultTime
            timer= setTimeout(() => {
              defaultTime--
              if (defaultTime <= 0 || !this.showSmsCountDown) {
                clearTimeout(timer)
                this.showSmsCountDown = false
                this.smsDisabled = true
                this.noCaptcha.reset();
                return
              }
              timeOut()
            }, 1000);
          }
          timeOut()
        }

        this.$refs.validForm.validate({
          names: ['mobile']
        }).then(() => {
          const { mobile, countryCode } = this.model
          runSmsCountDown()
          MainApi.fetchVerifySmsCode({
            mobile,
            countryCode,
            ...this.ncParams
          }).catch(() => {
            this.showSmsCountDown = false
            this.smsDisabled = true;
            this.noCaptcha.reset();
          })
        })
      },
      handleSubmit (event) {
        event.preventDefault()
        this.$refs.validForm.validate()
          .then(async () => {
            const license = this.model.license[0].url
            const params = Object.assign({}, this.model, { license })
            this.verifing = true
            await MainApi.saveClinetVerification(params)
            this.fetchUserInfo()
            this.$router.go(-1)
            this.verifing = false
          })
      },
      handleCancle () {
        this.$router.go(-1)
      },
      verifyCreditCode () {
        this.$refs.validForm.validate({
          names: ['companyName', 'creditCode']
        }).then(async () => {
          const { companyName: company_name, creditCode: credit_code } = this.model
          await MainApi.verifyCreditCode({
            company_name,
            credit_code: credit_code.toUpperCase()
          })
          this.isVerified = true
        })
      }
    },
    components: {
      UploadFile
    }
  }
</script>
<style lang="scss">
  .mm-form-field-children{
    position: initial;
  }
  .form-credit-code{
    .mm-form-field-control{
      position: relative;
    }
  }
</style>
<style lang="scss">
  .auth-form{
    width: 530px;
    padding-top: 40px;
    padding-bottom: 20px;
    margin: 0 auto;
    .nc_scale div.nc_bg {
      background: #cee1ff; /* 滑过时的背景色 */
    }
    .nc_scale .scale_text2 {
      color: #3683ff; /* 滑过时的字体颜色 */
    }
    .nc_scale .btn_ok {
      color: #0264ff;
    }
    .verify-btn{
      position: absolute; 
      top: 0;
      white-space: nowrap;
    }
    .auth-box{
      padding: 16px 14px 0;
      line-height: 20px;
      color: #5D5D5D;
      background: #F5F5F5;
      overflow: hidden;
      p{
        margin-bottom: 20px;
      }
    }
    .form-input-box{
      display: flex;
    }
    .form-mobile {
      .mm-input{
        width: 316px;
      }
    }
    .mm-input,
    .upload-file-box{
      width: 420px;
    }
    .mm-select{
      width: 88px;
      margin-right: 16px;
    }
    .license-tips{
      font-size: 12px;
      color: #909090;
    }
    .read-tips{
      font-weight: 600;
      cursor: pointer;
    }
    .read-tips-strong{
      color: $base-color;
    }
    .sms-button{
      width: 88px;
      padding: 0;
      margin-left: 16px;
      font-size: 12px;
    }
  }
  .footer{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 94px;
    border-top: 1px solid #D9D9D9;
    .mm-button{
      margin: 0 9px;
    }
  }
  .button-code{
    width: 86px;
    height: 32px;
    margin-left: 16px;
    border: 1px solid #B6B6B6;
    border-radius: 4px;
  }
  .mm-select-dropdown {
    width: 200px;
  }
</style>

